export class PaymentPayPalController {

  constructor($scope, $rootScope, $location, $window, PaymentService) {
    $scope.vm = this;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.location = $location;
    this.window = $window;
    this.PaymentService = PaymentService;

    this.init();
  }

  init() {
    this.PaymentService.createPaypal()
      .then((response) => { let res = response.data;
        this.window.location.href = res.redirectUrl;
      })
      .catch((response) => { let err = response.data;
        console.log(err);
        this.location.path('/homerd/centrodepago/fail')
      });
  }
}
